// extracted by mini-css-extract-plugin
export default {"form":"style_form__ht1uo","form_footer":"style_form_footer__lSZW-"};